module.exports = __webpack_public_path__ + "static/img/抖音号.878b2a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/抖音号.png
// module id = +wdj
// module chunks = 11